module.exports = __webpack_public_path__ + "static/media/rovan shot 06-mobile.2b61c8f5.webp";